import type { SelectHTMLAttributes } from 'react';

import styles from './Field.module.css';

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

// Выпадающий список формы — тот же язык, что Input, с кастомной кареткой.
export function Select({ className, children, ...rest }: SelectProps): JSX.Element {
  return (
    <select
      className={[styles.control, styles.select, className].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </select>
  );
}
